import * as yup from 'yup';

export const getDefaultCodeValidationValues = (initialData) => ({
  code: '',
  ...initialData,
});

const CodeValidationSchema = yup
  .object({
    code: yup
      .string()
      // .test('len', 'La longitud es de 24 caracteres', (val) => {
      //   if (val === undefined) {
      //     return true;
      //   }
      //   return new RegExp(/^\*{24}$/).test(val);
      // })
      .required('Requerido'),
    // pin: yup
    //   .string()
    //   .required('Requerido')
    //   .test('len', 'La longitud es de 4 dígitos', (val) => {
    //     if (val === undefined) {
    //       return true;
    //     }
    //     return new RegExp(/^\d{4}$/).test(val);
    //   }),
    // age: yup.number().positive().integer().required(),
  })
  .required();

export default CodeValidationSchema;
